export const joinLegalName = (name: string, suffix?: string): string =>
  [name?.trim(), suffix].filter(Boolean).join(" ");
